/**
 * The message the API actually sent, or null when it sent nothing usable
 * (GRAVY-10812).
 *
 * Reads `errors[0]` then `message`, matching what the
 * dashboard_v2 controllers render on a failure
 * (`{ success: false, errors: [...] }`). Untyped access on purpose — this runs
 * in a `catch`, where the value is genuinely `unknown` and a thrown Zod parse
 * error, a network failure and an HTTP error all arrive through it.
 *
 * Returns null rather than a generic string so the caller keeps its own
 * per-action fallback: a network drop really is "try again", and that wording
 * should survive for the cases where it is true.
 */
export const apiErrorMessage = (e: unknown): string | null => {
  const body = (e as { response?: { data?: unknown } })?.response?.data as
    | { errors?: unknown; message?: unknown }
    | undefined;
  if (!body) return null;

  const first = Array.isArray(body.errors) ? body.errors[0] : undefined;
  const message = typeof first === 'string' ? first : body.message;
  return typeof message === 'string' && message.trim() ? message : null;
};
